import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

// @mui
import { styled } from '@mui/material/styles';
import { Typography, Box, Button } from '@mui/material';

import pageTitle from "../utils/pageTitles.json";
import { BlankCard } from '../components/cards/blankCard';
import UsersListSvg from '../assets/svgs/usersList';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { useNavigate } from 'react-router-dom';
import { checkButtonAccess } from 'src/utils/common';
import { VoiceCliList } from 'src/sections/voice/cli/cliList';
import AddCli from 'src/sections/voice/cli/addCli';
import AddBulkassignCLi from 'src/sections/voice/cli/AddBulkassignCLi';

// home main section container.
const MainSection = styled('div')(({ theme }) => ({
    padding: "64px 20px 0px 88px",
    backgroundColor: "rgb(240, 240, 240)"/* theme.palette.background.default */,
    height: '100vh',
    overflow: 'hidden'
}));

// Show home hading and filtes
const HeadingSection = styled('div')(() => ({
    width: '100%',
    padding: "20px 0px 20px 0px",
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row'
}));


const HeadingContentSection = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'row',
    gap: '15px',
    alignItems: 'center',
    justifyContent: 'center',
}));

const DetailsListSection = styled('div')(() => ({
    width: '100%',
    height: 'calc(100vh - 155px)',//'554px',
    overflow: 'hidden',
    overflowY: "scroll",
}));


const VoiceCli = () => {
    const navigate = useNavigate();
    const [openModal, setOpenModal] = useState(false);
    const [openBulkAssignModal, setOpenBulkAssignModal] = useState(false);
    const [loadit, forceLoad] = useState(false);
    const [updateUserId, setUpdateUserId] = useState('');
    const [readdCli, setReaddCli] = useState(null);

    const handleClick = () => {
        setReaddCli(null);
        setOpenModal(true);
    }
    const handleBulkAssignClick = () => {
        setOpenBulkAssignModal(true);
    }
    const handleCloseModal = () => {
        setOpenModal(false);
        setUpdateUserId('');
        setReaddCli(null);
        
    };
    const handleCloseBulkAssignModal = () => {
        setOpenBulkAssignModal(false);
    };

    useEffect(() => {
        if (updateUserId || readdCli) {
            setOpenModal(true);
        }
    }, [updateUserId, readdCli]);


 

    return (
        <>
            <Helmet>
                <title> {`${pageTitle?.VoiceClient}`} </title>
            </Helmet>

            <MainSection>

                {/* Heading and filters */}
                <HeadingSection>
                    <HeadingContentSection>
                        <Box sx={{
                            widht: '16px',
                            height: '16px',
                            mt: "-10px",
                        }}>
                            <UsersListSvg />
                        </Box>
                        <Typography variant='h5' sx={{ color: 'grey.10', fontWeight: 600 }}>
                            Voice CLI List
                        </Typography>
                    </HeadingContentSection>
                    <Box sx={{ display: 'flex', gap: '12px' }}>
                    {checkButtonAccess("voiceCli", "w") && <Button
                        startIcon={<PersonAddIcon />}
                        sx={{
                            backgroundColor: 'rgb(33, 43, 54)',
                            color: 'grey.100',
                            p: '0px 20px 0px 20px',
                            '&:hover': {
                                backgroundColor: 'rgb(69, 79, 91)'
                            }
                        }}
                        onClick={() => handleClick()}
                    >
                        Add CLI / Delete CLI
                    </Button>}
                    {checkButtonAccess("voiceCli", "w") && <Button
                        sx={{
                            backgroundColor: 'rgb(33, 43, 54)',
                            color: 'grey.100',
                            p: '0px 20px 0px 20px',
                            '&:hover': {
                                backgroundColor: 'rgb(69, 79, 91)'
                            }
                        }}
                        onClick={() => handleBulkAssignClick()}
                    >
                        Bulk Assign/Remove CLI to User
                    </Button>}
                    </Box>
                </HeadingSection>

                <BlankCard
                    key="1"
                    sx={{
                        height: '100%',
                        width: '100%',
                        padding: '0px',
                        overflow: 'hidden',
                        // borderTopLeftRadius: '0px',
                        // borderTopRightRadius: '0px'
                    }}
                >
                <DetailsListSection className='reportListScroll'>
                    <VoiceCliList loadit={loadit}  setUpdateUserId={setUpdateUserId} forceLoad={forceLoad} setReaddCli={setReaddCli}/>
                </DetailsListSection>
                </BlankCard> 

            </MainSection>
            <AddCli
            openModal={openModal}
            forceLoad={forceLoad}
            loadit={loadit}
            handleCloseModal={handleCloseModal}
            updateUserId={updateUserId}
            readdCli={readdCli}
            />
            <AddBulkassignCLi
            openModal={openBulkAssignModal}
            forceLoad={forceLoad}
            handleCloseModal={handleCloseBulkAssignModal}
            />
           
        </>
    )
}


export default VoiceCli;
